import { stateful, useObservable } from '@adornis/functional-lit/stateful.js';
import { subscribeAccessibleClients } from '../../api/nexus-scoped-clients.js';
import { Client } from '@nsc/clients/entities/Client.js';
import { html } from 'lit';
import { ClientWorkspaceActions } from './ClientWorkspaceActions.js';

export const NexusClientWorkspacePage = stateful((props: { clientId: string }) => {
  const clients = useObservable(
    () =>
      subscribeAccessibleClients()({
        _id: 1,
        name: 1,
        enabled: 1,
        workflowType: 1,
        enabledFeatures: 1,
      }),
    [props.clientId],
  );

  const list = (Array.isArray(clients) ? clients : []) as Client[];
  const client = list.find(c => String(c._id) === String(props.clientId));

  return html`
    <div class="max-w-6xl mx-auto px-3 sm:px-4 py-6 flex flex-col gap-4 min-w-0">
      <a class="btn btn-ghost btn-sm w-fit" href="/">← Dashboard</a>
      ${clients === undefined
        ? html`<span class="loading loading-spinner loading-md"></span>`
        : !client
          ? html`<div class="alert alert-warning">This client is not available for your account.</div>`
          : ClientWorkspaceActions({ client })}
    </div>
  `;
});
